import {AccessKey} from "@amlCore/models";

export class AccessRules {
  id: AccessKey;
  readOnly: boolean;
  constructor() {
  }
}

